import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  buttonContainer: {
    width: '100%',
    alignItems: 'stretch',
    justifyContent: 'flex-end',
    gap: theme.spacing[3],
    marginTop: theme.spacing[7],
  },
  link: {
    textDecorationLine: 'underline',
  },
}));
